import { useEffect, useState } from "react";
import { getItems, getRules, subscribe } from "./labStore";

/** {items, rules} from the lab store; re-renders when either side changes them. */
export default function useLabStore() {
  const [state, setState] = useState(() => ({ items: getItems(), rules: getRules() }));
  useEffect(() => subscribe(() => setState({ items: getItems(), rules: getRules() })), []);
  return state;
}
